import { DateTime } from 'luxon'
import i18n from '@/i18n'

const unixtimeFromStr = (utcDateStr) => {
  const dt = DateTime.fromISO(utcDateStr)
  return dt.toUnixInteger()
}

export default {
  unixtimeFromStr,

  nowUtime() {
    const date = new Date()
    const now = date.getTime()
    return  Math.floor(now / 1000)
  },

  utcDateStrFromJsDate(jsDate) {
    const dt = DateTime.fromJSDate(jsDate);
    return dt.toUTC().toFormat("yyyy-MM-dd'T'HH:mm:ss'Z'")
  },

  unixtimeFromStr(utcDateStr) {
    const dt = DateTime.fromISO(utcDateStr)
    return dt.toUnixInteger()
  },

  currentStr(format=DateTime.DATETIME_MED) {
    return DateTime.now().toFormat(format)
  },

  localeStrFromUtcDate(utcDateStr, format='') {
    if (!format) format = DateTime.DATETIME_MED
    const dt = DateTime.fromISO(utcDateStr).setLocale(i18n.locale)
    return dt.toLocaleString(format)
  },

  localeStrFromUnixtime(utime, format='') {
    if (!format) format = DateTime.DATETIME_MED
    const dt = DateTime.fromSeconds(utime).setLocale(i18n.locale)
    return dt.toLocaleString(format)
  },

  calcFromNow(value, unit='seconds', isFuture=true, format='') {
    if (!format) format = "yyyy-MM-dd'T'HH:mm:ss'Z'"
    let calcObj = {}
    calcObj[unit] = value
    if (isFuture) {
      return DateTime.utc().plus(calcObj).toFormat(format)
    } else {
      return DateTime.utc().minus(calcObj).toFormat(format)
    }
  },

  calcRestTime(targetTime) {
    const date = new Date()
    const now = date.getTime()
    const nowUtime = Math.floor(now / 1000)
    const rest = targetTime - nowUtime
    if (rest < 0) return 0
    return rest
  },

  calcElapsedTime(startTime) {
    const date = new Date()
    const now = date.getTime()
    const nowUtime = Math.floor(now / 1000)
    const elapsed = nowUtime - startTime
    return elapsed
  },

  calcSpentTimeByDatetimeStr(startDatetimeStr, endDatetimeStr) {
    const startTime = unixtimeFromStr(startDatetimeStr)
    const endTime = unixtimeFromStr(endDatetimeStr)
    return endTime - startTime
  },
}
